var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 12.2501C3.98542 12.2501 3.65191 12.1114 3.37448 11.8339C3.09705 11.5565 2.95833 11.223 2.95833 10.8334V2.33341C2.95833 1.94383 3.09705 1.61032 3.37448 1.33289C3.65191 1.05546 3.98542 0.916748 4.375 0.916748H10.75C11.1396 0.916748 11.4731 1.05546 11.7505 1.33289C12.028 1.61032 12.1667 1.94383 12.1667 2.33341V10.8334C12.1667 11.223 12.028 11.5565 11.7505 11.8339C11.4731 12.1114 11.1396 12.2501 10.75 12.2501H4.375ZM1.54167 15.0834C1.15208 15.0834 0.818576 14.9447 0.541146 14.6673C0.263715 14.3898 0.125 14.0563 0.125 13.6667V3.75008H1.54167V13.6667H9.33333V15.0834H1.54167Z",
    fill: "#083F6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content_copy.483d39cb79424395c0e30677e77ce1c6.svg";
export { ForwardRef as ReactComponent };